import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import { useHistory } from 'react-router-dom';
import ChatBotIcon from 'web/assets/images/chat-bot.png';
import CloseIconWhite from 'web/assets/images/CloseIconWhite.png';
import ChatSendIcon from 'web/assets/images/ChatSendIcon.png';
import ChatUserIcon from 'web/assets/svg/ChatUserIcon';
import { Container } from "web/components/ChatBox/ChatBoxStyled";
import { userChatList, userSendMessage, makeMessagesRead } from '../../../redux/actions/chatSupport'

function ChatBox() {
  const dispatch = useDispatch();
  let history = useHistory();
  const [displayChatWindow, setDisplayChatWindow] = useState(false)
  const [chatList, setChatList] = useState([])
  const [message, setMessage] = useState('')
  const [unreadCount, setUnreadCount] = useState(0)

  useEffect(() => {
    const intervalCall = setInterval(() => {
      fetchMessageList();
    }, 60000);
    return () => clearInterval(intervalCall)
  }, [])

  const fetchMessageList = async () => {
    let response = '';
    let userAuthId = localStorage.getItem('authId')
    response = await dispatch(userChatList(userAuthId));
    if (response.status === 'SUCCESS') {
      if (response.payload && response.payload.chatMessages) {
        setChatList(response.payload.chatMessages)
        let count = 0
        count = response.payload.chatMessages.filter(val => (!val.readByUser && val.readByUser !== null)).length
        setUnreadCount(count)
      }
    }
  }

  const sendMessage = async (e) => {
    if (message?.trim() === '') setMessage(message?.trim())
    if (message?.trim() !== '' && (e === 'send' || (e.keyCode === 13 && !e.shiftKey))) {
      let userAuthId = localStorage.getItem('authId')
      let data = {
        userId: userAuthId,
        message: message,
        userType: "USER",
        senderId: userAuthId,
        receiverId: "75fb8f38-4596-4c3d-802a-784537b071ba"
      }
      let response = '';
      response = await dispatch(userSendMessage(data));
      if (response.status === 'SUCCESS') {
        fetchMessageList();
        setMessage('')
      } else {
        // if (response.message === "Unauthorized (Invalid token)") {
        //   history.push('/sign-in')
        //   window.location.reload(false);
        // }
      }
    }
  }

  const personChatClick = async (data) => {
    setDisplayChatWindow(true)
    let userAuthId = localStorage.getItem('authId')
    let response = await dispatch(makeMessagesRead(userAuthId));
  }

  const closeChatWindow = async () => {
    let userAuthId = localStorage.getItem('authId')
    let response = await dispatch(makeMessagesRead(userAuthId));
    setDisplayChatWindow(false)
  }

  return (
    <Container>
      {/* {loader && <Spinner />} */}
      <button className="open-button" onClick={personChatClick}>
        <img src={ChatBotIcon} alt='chat-bot-icon' />
      </button>
      {unreadCount > 0 ? <p className="unread-icon">{unreadCount}</p> : <></>}


      {displayChatWindow &&
        <div className="chat-popup" id="myForm">
          <div className="form-container">
            <div className="header">
              <p>PalletTrader Admin Chat</p>
              <button type="button" className="btn cancel" onClick={() => closeChatWindow()}>
                <img src={CloseIconWhite} alt='close-icon' />
              </button>
            </div>
            <div className='chat-window' style={{ overflow: 'auto', display: 'flex', flexDirection: 'column-reverse' }}>
              <div>
                {chatList && chatList.map(data => {
                  return (
                    <div className={data.userType === 'USER' ? 'chat-listing-user' : 'chat-listing-admin'}>
                      <ChatUserIcon color={data.userType === 'USER' ? "#0a5587" : "#6d7b69"} />
                      <div style={{ maxWidth: '85%', wordWrap: 'break-word' }}>
                        <p class={data.userType === 'USER' ? "chat-container" : "chat-container darker"}>{data.message}</p>
                        <span class={data.userType === 'USER' ? "time-right" : "time-left"}>
                          {moment(data.created * 1000).format('MMM Do, YYYY, HH:mm')}
                        </span>
                      </div>
                    </div>
                  )
                })}
                {chatList && chatList.length === 0 && <p style={{ textAlign: 'center', paddingTop: '90px' }}>No messages yet.</p>}
              </div>
            </div>
            <div className="footer">
              <textarea placeholder="Type message.." name="msg" required value={message}
                onChange={e => setMessage(e.target.value)}
                onKeyUp={e => sendMessage(e)}></textarea>
              <button className="btn enter-btn" >
                <img src={ChatSendIcon} onClick={() => sendMessage('send')} alt="image" />
              </button>
            </div>
          </div>
        </div>
      }
    </Container>
  )
};

export default ChatBox;
